const MAX_RECOVERY_CODES = 100;
const MAX_CODE_LENGTH = 256;

const IGNORED_LINE = /^(backup|recovery|emergency|one[- ]time|single[- ]use|c[oó]digos?|codes?|generated|generado|creado|created|keep|save|guardar|conservar|account|cuenta|service|servicio|date|fecha)\b/i;

const cleanCandidate = (value) => {
    let candidate = String(value ?? "")
        .replace(/^\uFEFF/, "")
        .replace(/^\s*["']|["']\s*$/g, "")
        .replace(/^\s*(?:[-*•]\s*|\d{1,3}[.)-]\s+)/, "")
        .trim();

    // Algunos proveedores exportan "Código 1: ABCD-EFGH".
    const labelled = candidate.match(/^(?:backup\s+code|recovery\s+code|code|c[oó]digo(?:\s+de\s+recuperaci[oó]n)?)(?:\s+\d+)?\s*[:=]\s*(.+)$/i);
    if (labelled?.[1]) candidate = labelled[1].trim();

    return candidate;
};

const isLikelyRecoveryCode = (candidate) => {
    if (!candidate || candidate.length < 4 || candidate.length > MAX_CODE_LENGTH) return false;
    if (IGNORED_LINE.test(candidate)) return false;
    if (/\b(?:backup|recovery)\s+codes?\b/i.test(candidate)) return false;
    if (/^https?:\/\//i.test(candidate)) return false;
    if (/^[\w.+-]+@[\w.-]+\.[a-z]{2,}$/i.test(candidate)) return false;

    // Evita guardar frases completas del encabezado del TXT como si fueran códigos.
    const words = candidate.split(/\s+/).filter(Boolean);
    const alphaNumericCount = (candidate.match(/[a-z0-9]/gi) || []).length;
    if (alphaNumericCount < 4) return false;
    if (words.length > 5 && !/[-_]/.test(candidate)) return false;

    return true;
};

export const extractRecoveryCodesFromText = (text = "") => {
    const rawParts = String(text ?? "")
        .replace(/\r/g, "")
        .split(/\n|\t|;|,(?=\s*[^\s])/g);

    const unique = new Set();

    for (const raw of rawParts) {
        const candidate = cleanCandidate(raw);
        if (!isLikelyRecoveryCode(candidate)) continue;
        unique.add(candidate);
        if (unique.size >= MAX_RECOVERY_CODES) break;
    }

    return Array.from(unique);
};

export const readRecoveryCodesFile = async (file) => {
    if (!file) return [];

    const name = String(file.name || "").toLowerCase();
    if (!name.endsWith(".txt") && !name.endsWith(".csv")) {
        throw new Error("El archivo debe ser .txt o .csv");
    }

    // Se lee localmente con File.text(). El File nunca se envía al backend.
    const text = await file.text();
    return extractRecoveryCodesFromText(text);
};

export const maskRecoveryCode = (code = "") => {
    const length = Math.max(8, Math.min(String(code).length, 14));
    return "•".repeat(length);
};
